import {
  RiClipboardLine,
  RiTimeLine,
  RiMoneyDollarCircleLine,
  RiFileTextLine,
  RiMoreLine,
  RiSparklingLine,
  RiGroupLine,
  RiReceiptLine,
} from "@remixicon/react";

interface IconProps {
  className?: string;
}

export const EllipsisIcon = ({ className = "w-4 h-4 text-[rgba(96,147,172,0.7)]" }: IconProps) => (
  <RiMoreLine className={className} />
);

export const ClipboardListIcon = ({ className = "w-4 h-4 text-[rgba(96,147,172,0.7)]" }: IconProps) => (
  <RiClipboardLine className={className} />
);

export const UsersIcon = ({ className = "w-4 h-4 text-[rgba(96,147,172,0.7)]" }: IconProps) => (
  <RiGroupLine className={className} />
);

export const FileTextIcon = ({ className = "w-4 h-4 text-[rgba(96,147,172,0.7)]" }: IconProps) => (
  <RiFileTextLine className={className} />
);

export const ReceiptIcon = ({ className = "w-4 h-4 text-[rgba(96,147,172,0.7)]" }: IconProps) => (
  <RiReceiptLine className={className} />
);

export const BanknoteIcon = ({ className = "w-4 h-4 text-[rgba(96,147,172,0.7)]" }: IconProps) => (
  <RiMoneyDollarCircleLine className={className} />
);

export const ClockIcon = ({ className = "w-4 h-4 text-[rgba(96,147,172,0.7)]" }: IconProps) => (
  <RiTimeLine className={className} />
);

export const SparklesIcon = ({ className = "w-5 h-5 text-white" }: IconProps) => (
  <RiSparklingLine className={className} />
);
